<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <user-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></user-add-form>
                <user-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></user-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import UserAddForm from './forms/add/representations/WizardForm'
    import UserUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../userStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            UserAddForm,
            UserUpdateForm
        },

    }
</script>
